import {gql, useMutation} from "@apollo/client";

const ADD_SEASON_MUTATION = gql`
    mutation AddSeason($input: AddSeasonInput!) {
        addSeason(input: $input) {
            season {
                id
                slug
                name
                registrationStartDate
                registrationEndDate
                startDate
                endDate
                state
                teams{
                    teamId
                    teamName
                    logo
                    team{
                        players{
                            id
                            playerId
                            fullName
                            shirtNumber
                            status
                            position{
                                key
                                name
                            }
                        }
                        slug
                    }
                }
                stages{
                    id
                    name
                    scheduleType
                    slug
                    hasResults
                    isDone
                    nextStage
                    gamesMode
                    teams
                    fields{
                        id
                        name
                    }
                }
                gamesCount
                playersCount
                pointSystem{
                    winPoints
                    drawPoints
                    losePoints
                    otWinPoints
                    otLossPoints
                    useOvertime
                    forfeitWinPoints
                    forfeitLossPoints
                    forfeitWinScore
                    forfeitLossScore
                    doubleForfeitPoints
                }
                waivers{
                    id
                    title
                }
                registrationFeeType
                registrationInstallments {
                    installmentNumber
                    amount
                    dueDate
                }
                lateRegistrationUntil
                lateRegistrationFee
                isRegistrationOpen
                isLateRegistrationOpen
                isRegistrationClosed
            }
        }
    }
`;

export default function AddSeasonMutation() {
    return useMutation(ADD_SEASON_MUTATION);
}
